import React, { useCallback, useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { UserContext } from "../../../../Context/UserContext";
import { debounce } from "lodash";
import { BaseURL } from "../../../../Reusable/BaseURL";
import ClipLoader from "react-spinners/ClipLoader";
import toast from "react-hot-toast";
// import AsyncSelect from "react-select/async";

export const IndentPOIndentSelect = ({
  selectedOption,
  setSelectedOption,
  changingSelect,
  setChangingSelect,
  partyId,
  partyVerify,
  divisionVerify,
  getUnsavedItemList,
}) => {
  const { darkTheme, loginData, setIndentPOCache, indentPOCache } =
    useContext(UserContext);

  const [options, setOptions] = useState([]);
  // const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Fetch initial data on component mount
  const initialData = async (id) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${BaseURL}/purchase/po/getindents?party_id=${id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${loginData.token}`,
          },
        }
      );
      const data = await response.json();
      const transformedOptions = data.data.data.map((item) => ({
        value: item.id,
        label: `${item.code} ${item.grade ? `(L-${item.grade})` : ""}`,
      }));
      const reverseOrder = transformedOptions.reverse()
      setOptions(reverseOrder);
      // setOptions(transformedOptions);
      if (data.status === true || data.status === false) {
        setIsLoading(false);
      }else{
        setIsLoading(false)
      }
    } catch (error) {
      // console.log("error", error);
      setIsLoading(false)
    }
  };
  useEffect(() => {
    initialData(partyId);
  }, [partyId]);
  useEffect(() => {
    if (divisionVerify !== "" || partyVerify !== "") {
      setSelectedOption("");
    }
  }, [divisionVerify, partyVerify]);

  // Function to fetch data based on input
  // const fetchData = useCallback(
  //   debounce(async (input) => {
  //     setIsLoading(true)
  //     const API_URL = `${BaseURL}/cities?q=${input}`;
  //       const response = await fetch(API_URL, {
  //         method: "GET",
  //         headers: {
  //           Accept: "application/json",
  //           Authorization: `Bearer ${loginData.token}`,
  //         },
  //       });
  //       const data = await response.json();
  //       const transformedOptions = data.data.data.map((item) => ({
  //         value: item.id,
  //         label: item.name,
  //       }));
  //       setOptions(transformedOptions);
  //       if(data.status===true || data.status === false){
  //         setIsLoading(false)
  //         }
  //   }, 300),
  //   []
  // );

  // GET INDENT PO CACHE DATA
  const setIndentCache = async (selec) => {
    setIsLoading(true);
    const ids = selec && selec.map((item, index) => item.value);
    const selectedPartyId = [...ids];
    const removeIndent = selectedPartyId.filter((item) => item !== selec.value);
    // console.log("removeIndent", selectedPartyId, removeIndent)

    const formData = {
      indent_ids: selectedPartyId,
    };
    const response = await fetch(`${BaseURL}/purchase/po/setcacheindents`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    const indents = data?.data?.items || [];
    // await setIndentPOCache(indents);
    if (data.status) {
      await setIndentPOCache(indents);
      await getUnsavedItemList();
    }
    if (data.status === false) {
      toast.error(data?.error?.message);
    }
    if (data.status === true || data.status === false) {
      setIsLoading(false);
    }
  };

  // Function to load options based on user input
  // const loadOptions = (inputValue, callback) => {
  //   fetch(`${BaseURL}/purchase/enquiry/getopenindents?q=${inputValue}`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       const options = data.data.map((item) => ({
  //         value: item.id,
  //         label: item.code,
  //         division: item.division,
  //         date: item.date,
  //         severity: item.severity,
  //       }));
  //       callback(options);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //       callback([]);
  //     });
  // };
  // const debouncedLoadOptions = debounce(loadOptions, 400);

  const handleFocus = () => {
    // fetchData(inputValue);
    // fetchInitialData()
    initialData(partyId);
  };

  // // Handle input change
  // const handleInputChange = (newValue) => {
  //   setInputValue(newValue);
  //   // fetchData(newValue);
  // };

  // Handle option select
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    // if(selectedOption.value){
    //   getIndent(selectedOption.value);
    // }
    setIndentCache(selectedOption);
  };

  // Custom styling
  const customStyles = {
    // loading style
    // menuList: (provided) => ({
    //   ...provided,
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center",
    //   minHeight: "50px",
    //   flexDirection: "column",
    //   textTransform: "uppercase",
    // }),
    container: (provided) => ({
      ...provided,
      width: "100%",
      margin: "0 auto",
      color: `${darkTheme ? "white" : "black"}`,
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      borderColor: "none",
      boxShadow: "none",
      "&:hover": {
        borderColor: "none",
      },
      borderRadius: "8px",
      border: "none",
      padding: "0 2px",
      color: `${darkTheme ? "white" : "black"}`,
      textTransform: "uppercase",
      border: `${darkTheme ? "1px solid #6B7280" : "1px solid #6B7280"}`,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      textTransform: "uppercase",
      border: "1px solid #6B7280",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2a60a0"
        : state.isFocused
        ? "#0ffa"
        : darkTheme
        ? "#374151"
        : "#ffff",
      color: state.isSelected ? "white" : "black",
      "&:active": {
        backgroundColor: "#aad",
        color: "white",
      },
      padding: "4px 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "black",
      fontWeight: "400",
      fontSize: "14px",
      textTransform: "uppercase",
    }),
  };

  const MenuList = (props) => {
    const { isLoading, children } = props;
    return (
      <components.MenuList {...props}>
        {isLoading ? (
          <div
            style={
              {
                // display: "flex",
                // flexDirection: "row",
                // justifyContent: "center",
                // alignItems: "center",
                // height: "100%",
              }
            }
          >
            <ClipLoader color="#000" loading={isLoading} size={30} />
          </div>
        ) : (
          children
        )}
      </components.MenuList>
    );
  };

  return (
    <Select
      onFocus={handleFocus}
      styles={customStyles}
      // cacheOptions
      // loadOptions={debouncedLoadOptions}
      // defaultOptions
      options={options}
      // onInputChange={handleInputChange}
      // inputValue={inputValue}
      onChange={handleChange}
      value={selectedOption}
      placeholder="Select"
      isLoading={isLoading}
      // components={{
      //   MenuList: (props) => <MenuList {...props} isLoading={isLoading} />,
      // }}
      closeMenuOnSelect={true}
      className="react-select-container"
      classNamePrefix="react-select"
      isClearable
      isMulti
      isDisabled={!partyId}
    />
  );
};
